import React from "react";

function EmtyDiv() {
  return <div className="opacity-0">2</div>;
}

export default React.memo(EmtyDiv);
